<template>
  <div class="app-container profile-page">
    <div class="profile-content">
      <el-card class="profile-card" shadow="hover">
        <div slot="header" class="profile-card__header">
          <div class="profile-card__title">變更密碼</div>
          <div class="profile-card__subtitle">為了帳號安全，建議定期更新密碼（至少 6 碼）。</div>
        </div>

        <el-form
          ref="profileForm"
          class="profile-form"
          :rules="profileRules"
          :model="profileForm"
          label-position="left"
          label-width="110px">
          <el-form-item label="目前密碼" prop="PASSWORD_CUR">
            <el-input
              :key="passwordTypes.PASSWORD_CUR"
              ref="profile_password_cur"
              v-model="profileForm.PASSWORD_CUR"
              :type="passwordTypes.PASSWORD_CUR"
              placeholder="請輸入目前密碼"
              prefix-icon="el-icon-key" />
            <span class="show-pwd" @click="showPwd('PASSWORD_CUR')">
              <svg-icon :icon-class="passwordTypes.PASSWORD_CUR === 'password' ? 'eye' : 'eye-open'" />
            </span>
          </el-form-item>

          <el-form-item label="新密碼" prop="PASSWORD_NEW">
            <el-input
              :key="passwordTypes.PASSWORD_NEW"
              ref="profile_password_new"
              v-model="profileForm.PASSWORD_NEW"
              :type="passwordTypes.PASSWORD_NEW"
              placeholder="請輸入新密碼"
              prefix-icon="el-icon-key" />
            <span class="show-pwd" @click="showPwd('PASSWORD_NEW')">
              <svg-icon :icon-class="passwordTypes.PASSWORD_NEW === 'password' ? 'eye' : 'eye-open'" />
            </span>
          </el-form-item>

          <el-form-item label="確認新密碼" prop="PASSWORD_NEW_AGAIN">
            <el-input
              :key="passwordTypes.PASSWORD_NEW_AGAIN"
              ref="profile_password_new_again"
              v-model="profileForm.PASSWORD_NEW_AGAIN"
              :type="passwordTypes.PASSWORD_NEW_AGAIN"
              placeholder="再次輸入新密碼"
              prefix-icon="el-icon-key"
              @keyup.enter.native="updateProfile" />
            <span class="show-pwd" @click="showPwd('PASSWORD_NEW_AGAIN')">
              <svg-icon :icon-class="passwordTypes.PASSWORD_NEW_AGAIN === 'password' ? 'eye' : 'eye-open'" />
            </span>
          </el-form-item>

          <div class="profile-actions">
            <el-button
              :loading="loading"
              type="primary"
              class="profile-actions__primary"
              @click.native.prevent="updateProfile">
              更新密碼
            </el-button>
          </div>
        </el-form>
      </el-card>

      <el-card class="security-tips-card" shadow="hover">
        <div slot="header" class="security-tips-card__header">
          <i class="el-icon-info" />
          <span class="security-tips-card__title">安全提示</span>
        </div>
        <div class="security-tips-content">
          <div class="security-tip-item">
            <i class="el-icon-check security-tip-icon" />
            <span>密碼長度至少 6 個字元，建議使用 8 個字元以上</span>
          </div>
          <div class="security-tip-item">
            <i class="el-icon-check security-tip-icon" />
            <span>建議使用英數混合，增加密碼強度</span>
          </div>
          <div class="security-tip-item">
            <i class="el-icon-check security-tip-icon" />
            <span>定期更新密碼，建議每 3-6 個月更換一次</span>
          </div>
          <div class="security-tip-item">
            <i class="el-icon-check security-tip-icon" />
            <span>不要與他人共用密碼，保護帳號安全</span>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'
import SvgIcon from '@/components/SvgIcon'

export default {
  name: 'Profile',
  components: {
    SvgIcon
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (!value || value.length < 6) {
        callback(new Error('密碼不能少於6位'))
      } else {
        callback()
      }
    }

    const validatePasswordNew = (rule, value, callback) => {
      if (!value || value.length < 6) {
        callback(new Error('密碼不能少於6位'))
      } else {
        if (value !== this.profileForm.PASSWORD_NEW) {
          callback(new Error('兩次密碼不一致'))
        } else {
          callback()
        }
      }
    }
    return {
      passwordTypes: {
        PASSWORD_CUR: 'password',
        PASSWORD_NEW: 'password',
        PASSWORD_NEW_AGAIN: 'password'
      },
      capsTooltip: false,
      loading: false,
      // USERNAME_NEW, PASSWORD_CUR, PASSWORD_NEW, FIRST_NAME, LAST_NAME
      profileForm: {
        PASSWORD_CUR: undefined,
        PASSWORD_NEW: undefined,
        PASSWORD_NEW_AGAIN: undefined
      },
      profileRules: {
        PASSWORD_CUR: [{ required: true, trigger: 'blur', validator: validatePassword }],
        PASSWORD_NEW: [{ required: true, trigger: 'blur', validator: validatePassword }],
        PASSWORD_NEW_AGAIN: [{ required: true, trigger: 'blur', validator: validatePasswordNew }]
      }
    }
  },
  computed: {
    ...mapGetters(['roles', 'USERNAME', 'FIRST_NAME', 'LAST_NAME'])
  },
  mounted() {},
  methods: {
    showPwd(field) {
      if (this.passwordTypes[field] === 'password') {
        this.passwordTypes[field] = ''
      } else {
        this.passwordTypes[field] = 'password'
      }
      this.$nextTick(() => {
        // 保持當前焦點在對應的輸入框
        const refName = `profile_${field.toLowerCase()}`
        if (this.$refs[refName]) {
          this.$refs[refName].focus()
        }
      })
    },
    updateProfile() {
      this.$refs.profileForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch('user/updatePassword', this.profileForm)
            .then(() => {
              Message({
                message: '成功',
                type: 'success',
                duration: 2 * 1000
              })
              // 先清除驗證狀態，避免清空時觸發驗證提示
              this.$refs.profileForm.clearValidate()
              // 重置所有密碼欄位的顯示狀態
              this.passwordTypes.PASSWORD_CUR = 'password'
              this.passwordTypes.PASSWORD_NEW = 'password'
              this.passwordTypes.PASSWORD_NEW_AGAIN = 'password'
              // 清空所有密碼欄位
              this.$nextTick(() => {
                this.profileForm.PASSWORD_CUR = undefined
                this.profileForm.PASSWORD_NEW = undefined
                this.profileForm.PASSWORD_NEW_AGAIN = undefined
                // 聚焦到第一個輸入框
                if (this.$refs.profile_password_cur) {
                  this.$refs.profile_password_cur.focus()
                }
              })
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.profile-page {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 40px;
}

.profile-content {
  width: 100%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.profile-card {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
  }
}

.profile-card__header {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.profile-card__title {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
}

.profile-card__subtitle {
  font-size: 13px;
  color: #909399;
}

.profile-form {
  padding-top: 6px;
}

.profile-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 6px;
}

.profile-actions__primary {
  min-width: 140px;
}

.show-pwd {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #909399;
  cursor: pointer;
  user-select: none;

  &:hover {
    color: #42b983;
  }
}

.profile-form {
  .el-form-item {
    position: relative;
  }
}

.security-tips-card {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
  }
}

.security-tips-card__header {
  display: flex;
  align-items: center;
  gap: 8px;

  .el-icon-info {
    color: #5b9bd5;
    font-size: 18px;
  }
}

.security-tips-card__title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.security-tips-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 0;
}

.security-tip-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;

  .security-tip-icon {
    color: #388e3c;
    font-size: 16px;
    margin-top: 2px;
    flex-shrink: 0;
  }
}
</style>
